import { render, staticRenderFns } from "./AdsBlockedNotice.vue?vue&type=template&id=fc85158a&scoped=true&"
import script from "./AdsBlockedNotice.vue?vue&type=script&lang=js&"
export * from "./AdsBlockedNotice.vue?vue&type=script&lang=js&"
import style0 from "./AdsBlockedNotice.vue?vue&type=style&index=0&id=fc85158a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc85158a",
  null
  
)

export default component.exports